import React from 'react';
import { useHistory } from 'react-router';
import { ErrorBoundaryInner } from './error-boundary-inner';

const ErrorBoundary: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<ErrorBoundaryProps>>
> = props => {
  const history = useHistory();

  return (
    <ErrorBoundaryInner history={history} onError={props.onError}>
      {props.children}
    </ErrorBoundaryInner>
  );
};

interface ErrorBoundaryProps {
  onError: (error: any) => void | React.ReactNode;
  children: React.ReactNode;
}

export default ErrorBoundary;
